import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUsersContext } from '../../../contexts/users.tsx';
import LogoutHeader from './header.tsx';

const Logout = () => {
    const { isLoggedIn, logout } = useUsersContext();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (isLoggedIn)
            logout();

        if (!isLoggedIn) {
            navigate("/login");
        }
    }, [isLoggedIn, navigate]);

    if (!isLoggedIn) {
        return null;
    }

    return (
        <LogoutHeader />
    );
};

export default Logout;
